import React, { useState, useEffect } from 'react';
import { PubSub } from 'aws-amplify'
import { Container, Table, ToggleButtonGroup } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Button, { ButtonProps } from '@mui/material/Button';
import  RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'; 
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CardActions from '@mui/material/CardActions';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Typography from "@mui/material/Typography";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ToggleButton from '@mui/material/ToggleButton';
import moment from 'moment'
import Modal from "@mui/material/Modal";
import Box from '@mui/material/Box';
import { API } from '@aws-amplify/api';



export default function URelay(props) {
    console.log('URelay props', props);
    const handler = props.clickHandler;
    const switch_io = props.io;  
    const device_info = props.device;
    const position = props.position;
    
    const switch_config = props.config;
    const switch_type = props.config.type;

    function sendCommand(message)
    {
      var pubSetterTopic = `$aws/things/${device_info.mac}/shadow/name/io/update`;
      var js_fmt = JSON.parse(message);
      PubSub.publish(pubSetterTopic, js_fmt);    
      console.log('message published to ',pubSetterTopic, 'message:', message); 
    }


    function handleClick(e)
    {
      console.log("Target element:", e.target);
      var click_target = e.target;
      var id = "a." + click_target.getAttribute('id');
      console.log('inner id',id);
      var device = click_target.getAttribute('device');
      var type = click_target.getAttribute('type');
      var state = click_target.getAttribute('state');
      var setting = click_target.getAttribute('setting');
      var position = click_target.getAttribute('position');
      var unit = click_target.getAttribute('unit');
      console.log('unit',unit);

      var alertmsg = `{"state":{"desired":{"${unit}.state":${setting}}}}`;
      /*
{
  "state": {
    "reported": {
      "a.Relays.0.state": 0,
      "a.Relays.1.state": 1,
      "a.GPIOs.0.state": 1,
      "a.GPIOs.1.state": 0
    }
  }
}
      */
      sendCommand(alertmsg);
      // +  "/unit:" +  + String(unit) + "/postion:" + position + "=" + setting;
      //alert(alertmsg);
    }


    return (
        <div>
        {switch_type > 1
          ?     
            <Button
                key={"Relays.0" + device_info + "."  + switch_config.index}
                id={"Relays." + switch_config.index}
                unit={"a.Relays." + position}
                state={switch_io.state}
                setting={switch_io.state===0?1:0}
                device={device_info.mac}
                type={switch_type}
                variant="contained"
                size="small"

                onClick={(e) => handleClick(e)}>           
                {switch_config.name} TOGGLE
            
            </Button>
          :
            <>         
           
            SwitchState {JSON.stringify(switch_io)}SHOWS HERE
        <Box
          sx={{
            width: 100,
            height: 100,
            borderRadius: 1,
            bgcolor: switch_io.state===0 ? "notasserted.main" : "asserted.main",

          }}
        >
 {switch_config.name}

              <Button
                key={"Relays.0" + device_info + "."  + switch_config.index}
                id={"Relays." + switch_config.index}
                variant="contained"
                size="small"             
                state={switch_io.state}
                setting={0}
                unit={"a.Relays." + position}
                position={position}
                type={switch_type}
                device={device_info.mac}               
                onClick={(e) => handleClick(e)}
                sx={{color: "black", bgcolor: "notasserted.main"}}
                
                >
                OFF
              </Button>
            <Button          
              key={"Relays.1" + device_info + "."  + switch_config.index}
              id={"Relays." + switch_config.index}
              state={switch_io.state}
              setting={1}
              unit={"a.Relays." + position}
              position={position}
              type={switch_type}
              device={device_info.mac}
              variant="contained"
              size="small"
              sx={{color: "black", bgcolor: "asserted.main"}}
              
              onClick={(e) => handleClick(e)}
             
            >
             ON
            </Button>
            </Box>
            </>
      }


      </div>

  )
}

